import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/cih/stories")({
  staticData: { title: "Success Stories" },
  component: () => <Outlet />,
});
